/* eslint-disable max-len */
import React from 'react';

interface IVisaProps {
    width?: number;
    height?: number;
}

const Visa: React.FC<IVisaProps> = ({width = 40, height = 14}) => {

    return (
        <svg width={width} height={height} viewBox="0 0 40 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_14967_273410" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="14">
                <path d="M40 0H0V14H40V0Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_14967_273410)">
                <path d="M15.188 0.24835L9.95 13.7878H6.533L3.956 2.98242C3.8 2.3164 3.665 2.07257 3.188 1.79261C2.41 1.33656 1.127 0.9076 0 0.64119L0.0770035 0.24835H5.577C6.277 0.24835 6.90801 0.75407 7.06701 1.63006L8.42701 9.4643L11.792 0.24835H15.188ZM28.575 9.3672C28.59 5.79326 24.015 5.59684 24.046 4.00065C24.056 3.51524 24.483 2.99823 25.417 2.86728C25.879 2.80181 27.156 2.75214 28.604 3.47234L29.171 0.60055C28.394 0.2935 27.394 0 26.148 0C22.952 0 20.704 1.84003 20.685 4.47702C20.665 6.42542 22.29 7.5136 23.515 8.1616C24.775 8.8254 25.198 9.2521 25.192 9.8436C25.183 10.7512 24.188 11.153 23.256 11.1688C21.631 11.1959 20.69 10.6925 19.938 10.3132L19.352 13.2798C20.106 13.6546 21.502 13.9819 22.946 14C26.344 14 28.565 12.1826 28.575 9.3672ZM37.01 13.7878H40L37.39 0.24835H34.631C34.01 0.24835 33.488 0.63893 33.256 1.24174L28.406 13.7878H31.8L32.475 11.7649H36.621L37.01 13.7878ZM33.404 8.9902L35.106 3.90582L36.085 8.9902H33.404ZM19.806 0.24835L17.133 13.7878H13.9L16.575 0.24835H19.806Z" fill="#899696"/>
            </g>
        </svg>
    );
};

export default Visa;